import React from 'react';
import { motion } from 'framer-motion';
import { Check, X, Crown, ChevronRight, Sparkles } from 'lucide-react';
import { useInView } from '../hooks/useInView';
import { trackAndRedirect } from '../lib/tracking';
const basicIncludes = ['Libro principal El Código 888', '6 Archivos Maestros de lectura privada', 'Protocolos de claridad y enfoque emocional', 'Biblioteca inicial digital', 'Acceso inmediato', 'Experiencia privada de introspección'];
const basicExcludes = ['Sala VIP de meditación', 'Audios inmersivos extendidos', 'Biblioteca premium completa', 'Frecuencias guiadas privadas'];
const vipIncludes = ['Todo lo del Acceso Inicial', '9 Archivos Maestros premium', 'Sala VIP privada de meditación', 'Más de 40 minutos de audios inmersivos', 'Frecuencias guiadas y sesiones de relajación', 'Biblioteca extendida completa', 'Experiencia profunda de calma y presencia', 'Contenido diseñado para crear momentos de claridad interior', 'Acceso completo a la experiencia VIP'];
export function ComparacionPlanesSection() {
  const [headerRef, headerInView] = useInView({
    threshold: 0.2
  });
  const [cardsRef, cardsInView] = useInView({
    threshold: 0.1
  });
  const handleBasic = () => {
    trackAndRedirect(14.39, 'Main_Offer', 'https://betterdailyguides.com/cart/51973733482798:1');
  };
  const handleVip = () => {
    trackAndRedirect(26.39, 'Complete_Experience', 'https://www.betterdailyguides.com/cart/51978554671406:1');
  };
  return <section id="comparacion" className="relative py-16 sm:py-24 bg-[#050505] border-t border-white/5 overflow-hidden scroll-mt-[56px] sm:scroll-mt-[70px]" aria-label="Comparación de planes" data-id="element-147">
      {/* Premium gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,#0B0B0B_0%,#050505_100%)] pointer-events-none" data-id="element-148" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[500px] bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.08),transparent_70%)] pointer-events-none" data-id="element-149" />

      <div className="max-w-6xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-150">
        {/* Header */}
        <motion.div ref={headerRef} initial={{
        opacity: 0,
        y: 30
      }} animate={headerInView ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 30
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12 sm:mb-16" data-id="element-151">
          <span className="inline-block text-gold sm:text-xs font-bold tracking-[3px] uppercase mb-4 text-[12px]" data-id="element-152">
            Elige tu camino
          </span>
          <h2 className="font-serif text-3xl sm:text-4xl md:text-5xl font-black text-white mb-5 leading-tight" data-id="element-153">
            Dos accesos.{' '}
            <span className="text-gold" data-id="element-154">Una misma experiencia interior.</span>
          </h2>
          <p className="text-white/70 text-base sm:text-lg max-w-2xl mx-auto font-medium leading-relaxed" data-id="element-155">
            Comienza con lo esencial o entra a la experiencia inmersiva
            completa.
          </p>
        </motion.div>

        {/* Cards */}
        <div ref={cardsRef} className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8 items-stretch" data-id="element-156">
          {/* BASIC */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={cardsInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.7
        }} className="relative flex flex-col bg-[#0c0c0e] border border-white/10 rounded-2xl sm:rounded-3xl p-6 sm:p-9 transition-all duration-300 hover:border-white/20" data-id="element-157">
            <div className="mb-6" data-id="element-158">
              <span className="inline-block text-white/50 text-[10px] sm:text-xs font-bold tracking-[2.5px] uppercase mb-3" data-id="element-159">
                Punto de entrada
              </span>
              <h3 className="font-serif text-2xl sm:text-3xl font-black text-white mb-2" data-id="element-160">
                Acceso Inicial
              </h3>
              <p className="text-white/60 text-sm sm:text-base font-medium" data-id="element-161">
                Tu entrada al universo Código 888.
              </p>
            </div>

            {/* Price */}
            <div className="mb-7 pb-7 border-b border-white/10" data-id="element-162">
              <div className="text-4xl sm:text-5xl font-black text-white pl-[0px] pr-[0px]" data-id="element-163">
                $14.39
              </div>
              <p className="text-white/40 text-xs sm:text-sm mt-1 font-medium" data-id="element-164">
                Pago único · Acceso inmediato
              </p>
            </div>

            {/* Includes */}
            <ul className="space-y-3 mb-6" role="list" data-id="element-165">
              {basicIncludes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-166">
                  <span className="shrink-0 flex items-center justify-center w-5 h-5 rounded-full bg-gold/15 text-gold mt-0.5" data-id="element-167">
                    <Check className="w-3 h-3" strokeWidth={3} data-id="element-168" />
                  </span>
                  <span className="text-white/85 text-sm sm:text-base leading-relaxed" data-id="element-169">
                    {item}
                  </span>
                </li>)}
            </ul>

            {/* Excludes */}
            <div className="mb-8 pt-5 border-t border-white/5" data-id="element-170">
              <p className="text-white/40 text-[10px] sm:text-xs font-bold tracking-wider uppercase mb-3" data-id="element-171">
                No incluye
              </p>
              <ul className="space-y-2.5" role="list" data-id="element-172">
                {basicExcludes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-173">
                    <span className="shrink-0 flex items-center justify-center w-5 h-5 rounded-full bg-white/5 text-white/30 mt-0.5" data-id="element-174">
                      <X className="w-3 h-3" strokeWidth={3} data-id="element-175" />
                    </span>
                    <span className="text-white/40 text-xs sm:text-sm leading-relaxed line-through decoration-white/20" data-id="element-176">
                      {item}
                    </span>
                  </li>)}
              </ul>
            </div>

            {/* CTA */}
            <button onClick={handleBasic} className="mt-auto w-full min-h-[52px] py-4 px-6 rounded-xl bg-white/10 hover:bg-white/15 border border-white/15 text-white font-black text-sm sm:text-base uppercase tracking-wider transition-all duration-300 active:scale-[0.98] flex items-center justify-center gap-2" data-id="element-177">
              Comenzar Experiencia
              <ChevronRight className="w-4 h-4" data-id="element-178" />
            </button>
          </motion.div>

          {/* VIP */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} animate={cardsInView ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.7,
          delay: 0.15
        }} whileHover={{
          y: -4
        }} className="relative pt-4 lg:-mt-2" data-id="element-179">
            {/* Ambient outer glow halo — sits BEHIND the card for cinematic depth */}
            <div aria-hidden="true" className="absolute -inset-4 sm:-inset-6 rounded-[2.5rem] bg-[radial-gradient(ellipse_at_center,rgba(212,175,55,0.22),transparent_65%)] blur-3xl pointer-events-none -z-10" data-id="element-180" />
            <div aria-hidden="true" className="absolute inset-x-8 -top-2 h-12 bg-gold/20 blur-3xl rounded-full pointer-events-none -z-10" data-id="element-181" />

            {/* Badge — sits ABOVE the card, outside the overflow-hidden wrapper */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 sm:left-auto sm:right-9 sm:translate-x-0 z-20" data-id="element-182">
              <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-gold text-black text-[10px] sm:text-xs font-black uppercase tracking-[1.5px] shadow-[0_5px_20px_rgba(212,175,55,0.5)] whitespace-nowrap" data-id="element-183">
                <Sparkles className="w-3 h-3" data-id="element-184" />
                Experiencia Completa
              </div>
            </div>

            <div className="relative flex flex-col h-full bg-gradient-to-b from-[#13131a] via-[#0e0e12] to-[#0A0A0B] border border-gold/50 rounded-2xl sm:rounded-3xl p-6 sm:p-9 shadow-[0_30px_80px_rgba(0,0,0,0.7),0_0_80px_rgba(212,175,55,0.2),inset_0_1px_0_rgba(255,255,255,0.06)] overflow-hidden transition-shadow duration-500 hover:shadow-[0_40px_100px_rgba(0,0,0,0.8),0_0_100px_rgba(212,175,55,0.3),inset_0_1px_0_rgba(255,255,255,0.08)]" data-id="element-185">
              {/* Background glow */}
              <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-lg h-full bg-[radial-gradient(ellipse_at_top,rgba(212,175,55,0.15),transparent_70%)] pointer-events-none" data-id="element-186" />

              <div className="relative z-10 flex flex-col h-full" data-id="element-187">
                <div className="mb-6" data-id="element-188">
                  <span className="inline-flex items-center gap-1.5 text-gold text-[10px] sm:text-xs font-bold tracking-[2.5px] uppercase mb-3" data-id="element-189">
                    <Crown className="w-3.5 h-3.5" data-id="element-190" />
                    Inmersión total
                  </span>
                  <h3 className="font-serif text-2xl sm:text-3xl font-black text-white mb-2" data-id="element-191">
                    Sala Maestra <span className="text-gold" data-id="element-192">VIP</span>
                  </h3>
                  <p className="text-white/70 text-sm sm:text-base font-medium" data-id="element-193">
                    La experiencia inmersiva completa.
                  </p>
                </div>

                {/* Price */}
                <div className="mb-7 pb-7 border-b border-gold/15" data-id="element-194">
                  <div className="text-4xl sm:text-5xl font-black text-white drop-shadow-[0_0_25px_rgba(212,175,55,0.35)] pl-[0px] pr-[0px]" data-id="element-195">
                    $26.39
                  </div>
                  <p className="text-gold/80 text-xs sm:text-sm mt-1 font-bold" data-id="element-196">
                    Pago único · Acceso inmediato de por vida
                  </p>
                </div>

                {/* Includes */}
                <ul className="space-y-3 mb-8" role="list" data-id="element-197">
                  {vipIncludes.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-198">
                      <span className="shrink-0 flex items-center justify-center w-5 h-5 rounded-full bg-gold/20 text-gold mt-0.5 shadow-[0_0_10px_rgba(212,175,55,0.3)]" data-id="element-199">
                        <Check className="w-3 h-3" strokeWidth={3} data-id="element-200" />
                      </span>
                      <span className={`text-sm sm:text-base leading-relaxed ${i === 0 ? 'text-gold font-bold' : 'text-white/90'}`} data-id="element-201">
                        {item}
                      </span>
                    </li>)}
                </ul>

                {/* CTA */}
                <button onClick={handleVip} className="mt-auto w-full min-h-[56px] py-4 px-6 rounded-xl bg-gradient-to-r from-gold via-yellow-400 to-gold text-black font-black text-sm sm:text-base uppercase tracking-wider shadow-[0_15px_40px_rgba(212,175,55,0.4)] hover:shadow-[0_20px_50px_rgba(212,175,55,0.6)] hover:scale-[1.02] active:scale-[0.98] transition-all duration-300 flex items-center justify-center gap-2 relative overflow-hidden group/btn" data-id="element-202">
                  <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/40 to-transparent -translate-x-full animate-shimmer" data-id="element-203" />
                  <span className="relative z-10 flex items-center gap-2" data-id="element-204">
                    Entrar a la Experiencia VIP
                    <ChevronRight className="w-4 h-4" data-id="element-205" />
                  </span>
                </button>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}